// Money primitives. Today the app is USD-only, but every price flows through
// `formatMoney` so swapping in a multi-currency display later is a config
// change, not a refactor.
//
// API shape we expect from NetSuite:
//   price:  { amount: 595, currency: "USD" }            (canonical)
//   prices: [{ currency: "USD", amount: 595 }, ...]     (optional, future)
// Plain numbers are also accepted and assumed USD.

export const DEFAULT_CURRENCY = "USD";

export function toMoney(input, currency = DEFAULT_CURRENCY) {
  if (input == null) return null;
  if (typeof input === "number") return { amount: input, currency };
  if (typeof input === "string") {
    const n = Number(input);
    return Number.isFinite(n) ? { amount: n, currency } : null;
  }
  if (typeof input === "object" && "amount" in input) {
    return { amount: Number(input.amount) || 0, currency: input.currency || currency };
  }
  return null;
}

export function pickPrice(item, displayCurrency = DEFAULT_CURRENCY) {
  if (!item) return null;
  if (Array.isArray(item.prices) && item.prices.length) {
    const match = item.prices.find((p) => p.currency === displayCurrency);
    if (match) return toMoney(match);
    return toMoney(item.prices[0]);
  }
  return toMoney(item.price, displayCurrency);
}

export function formatMoney(money, opts = {}) {
  const m = toMoney(money);
  if (!m) return "—";
  const { locale = "en-US", minimumFractionDigits, maximumFractionDigits } = opts;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: m.currency || DEFAULT_CURRENCY,
    minimumFractionDigits: minimumFractionDigits ?? 2,
    maximumFractionDigits: maximumFractionDigits ?? 2,
  }).format(m.amount);
}
